import { createAxiosInstance } from "../../axios/createAxiosInstance";
import { ROLES } from "../../utils/userRole";

// Create admin axios instance with refresh token handling and telemetry
const axiosAdminInstance = createAxiosInstance({
  baseURL: process.env.REACT_APP_API_URL + "/admin",
  tokenKey: "adminToken",
  userType: "admin",
  endpointPrefix: "/admin",
  role: ROLES.ADMIN,
});

export default axiosAdminInstance;
